import type { TOCChild, TOCItem } from '~/common/types';

export function collectLeaves(items: readonly TOCItem[]): TOCChild[] {
  return items.flatMap((item) => ('children' in item ? collectLeaves(item.children) : [item]));
}
